<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :disabled="assignClerkDisabled"
          class="warning mr-1"
          fab
          x-small
          v-on="{ ...tooltip }"
          @click="transferClerk()"
        >
          <v-icon>mdi-account-switch</v-icon>
        </v-btn>
      </template>
      <span>TRANSFER CLERK</span>
    </v-tooltip>

    <!-- THE DIALOG BEGINS HERE -->

    <v-dialog v-model="dialogTransferClerk" max-width="750px">
      <template v-if="editedCasefile">
        <v-card>
          <v-card-title class="justify-center text-h5 grey lighten-2">
            <span class="text-h5">TRANSFER CLERK</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="branch.brCode"
                    :items="sortedBranches"
                    item-text="name"
                    item-value="brCode"
                    :menu-props="{ maxHeight: '400' }"
                    label="BRANCH"
                    hint="Select Branch"
                    persistent-hint
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editedCasefile.clerkInCharge"
                    :items="sortedClerksByBranch(branch.brCode)"
                    item-text="username"
                    item-value="id"
                    no-data-text="There is no Clerk for the branch above"
                    :menu-props="{ maxHeight: '400' }"
                    label="CLERK"
                    hint="Assign Clerk"
                    persistent-hint
                    clearable
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    tile
                    small
                    dark
                    @click="closeTransferClerkDialog"
                    class="mt-3 mr-2 error"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    tile
                    small
                    :disabled="isAddFileButtonDisabled"
                    class="mt-3 success"
                    @click="transferClerkSubmit"
                    >Submit</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import MailDataService from "../../services/MailDataService";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "branchAccept",
  props: [
    "branches",
    "management",
    "insurer",
    "refType",
    "subRefTypes",
    "members",
    "handlers",
    "states",
    "regions",
    "adjusters",
    "clerks",
  ],
  components: {},

  data() {
    return {
      dialogTransferClerk: false,
      menu: false,
      menu1: false,
      branch: {
        name: "",
        brCode: "",
      },
      editedCasefile: null, // Local copy for editing
    };
  },

  computed: {
    ...mapState(["caseState"]),
    isAddFileButtonDisabled() {
      return (
        !this.editedCasefile ||
        !this.editedCasefile.clerkInCharge ||
        !this.branch.brCode
      );
    },
    sortedBranches() {
      const list = this.branches || [];
      return list
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedClerksByBranch() {
      return (brCode) => {
        const list = this.clerks || [];
        return list
          .filter(
            (r) =>
              Array.isArray(r.branches) &&
              r.branches.some((i) => i.brCode === brCode)
          )
          .map((clerk) => ({
            ...clerk,
            username: clerk.username ? clerk.username.trim().toUpperCase() : "",
          }))
          .sort((a, b) => a.username.localeCompare(b.username));
      };
    },

    assignAdjRule() {
      return !(this.branch.brCode && this.caseState.casefile.adjuster);
    },

    assignClerkRule() {
      return !(this.branch.brCode && this.caseState.casefile.clerkInCharge);
    },

    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("DD/MM/YY") : "";
    },

    assignClerkDisabled() {
      return (
        this.caseState.casefile.fileStatus == `NEW` ||
        this.caseState.casefile.fileStatus == `PEND` ||
        this.caseState.casefile.fileStatus == `BRAC` ||
        this.caseState.casefile.fileStatus == `ADAC` ||
        this.caseState.casefile.fileStatus == `INVE` ||
        this.caseState.casefile.fileStatus == `PEDI` ||
        this.caseState.casefile.fileStatus == `EDAC` ||
        this.caseState.casefile.fileStatus == `EDI` ||
        this.caseState.casefile.fileStatus == `PAPP` ||
        this.caseState.casefile.fileStatus == `HOLD` ||
        this.caseState.casefile.fileStatus == `PFORM` ||
        this.caseState.casefile.fileStatus == `CANC` ||
        this.caseState.casefile.fileStatus == `CLO` ||
        !this.management
      );
    },
  },
  watch: {
    transferAdj(val) {
      val || this.closeAdj();
    },
    transferClerk(val) {
      val || this.closeClerk();
    },
  },

  methods: {
    currentUserBranch() {
      if (
        this.$store.state.auth.user.roles.includes("MANAGER") ||
        this.$store.state.auth.user.roles.includes("ADMIN") ||
        this.$store.state.auth.user.roles.includes("CLERK")
      ) {
        return this.branches;
      } else
        return this.branches.filter(
          (x) => x.id === this.caseState.casefile.branch
        );
    },

    filtersubRefType(item) {
      return this.subRefTypes.filter(
        (subRefType) => subRefType.deptId === item
      );
    },
    filterHandler(item) {
      return this.handlers.filter((handler) => handler.insId === item);
    },
    filterBranchName(item) {
      if (!item) return "TBA";
      const filteredbranch = this.branches.filter(
        (branch) => branch.id === item
      );
      return filteredbranch[0].name;
    },
    filterBranches(item) {
      return this.branches.filter((branch) => branch.id === item);
    },

    filterRegions(item) {
      return this.regions.filter((region) => region.branchId === item);
    },
    filterPicID(item) {
      if (!item) return "TBA";
      const filteredDept = this.refType.filter((dept) => dept.id === item);
      return filteredDept[0].picID;
    },

    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },
    filterSubDept(item) {
      return this.subRefTypes.filter((subRef) => subRef.id === item);
    },
    filterIns(item) {
      return this.insurer.filter((insurer) => insurer.id === item);
    },
    findAdjEmail(item) {
      const adjuster = this.adjusters.filter(
        (adjuster) => adjuster.id === item
      );
      return (
        adjuster.map((b) => b.email) || "sys.admin@associatedadjusters.com"
      );
    },
    findClerkEmail(item) {
      const clerk = this.clerks.filter((clerk) => clerk.id === item);
      return clerk.map((b) => b.email) || "sys.admin@associatedadjusters.com";
    },
    findUserEmail(item) {
      const user = this.members.filter((member) => member.id === item);
      return user[0] ? user[0].email : "sys.admin@associatedadjusters.com";
    },

    filterAdjByBranch(item) {
      return this.adjusters.filter((r) =>
        r.branches.some((i) => i.brCode === item)
      );
    },

    filterClerkByBranch(item) {
      return this.clerks.filter((r) =>
        r.branches.some((i) => i.brCode === item)
      );
    },

    transferAdj() {
      this.dialogAdj = true;
    },

    transferClerk() {
      // Clone casefile for local editing
      this.editedCasefile = JSON.parse(JSON.stringify(this.caseState.casefile));
      // Reset branch selection to match casefile (if exists)
      if (this.caseState.casefile.branch) {
        const branchObj = this.branches.find(
          (b) => b.id === this.caseState.casefile.branch
        );
        this.branch = branchObj
          ? { name: branchObj.name, brCode: branchObj.brCode }
          : { name: "", brCode: "" };
      } else {
        this.branch = { name: "", brCode: "" };
      }
      this.dialogTransferClerk = true;
    },

    saveAdjuster() {
      CasefileDataService.update(
        this.caseState.casefile.id,
        this.caseState.casefile,
        (this.caseState.casefile.dateOfAdj = moment().format()),
        (this.caseState.casefile.assignAdjBy = this.$store.state.auth.user.id)
      )

        .then((response) => {
          this.closeAdj();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        })

        .then(() => {
          const assignedAdjuster = this.caseState.casefile.adjuster;
          var dataEmail = {
            id: this.caseState.casefile.id,
            refType: this.filterDept(this.caseState.casefile.refType)[0]
              .description,
            refTypeCode: this.filterDept(this.caseState.casefile.refType)[0]
              .name,
            subRefType: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCodeDesc,
            subRefCode: this.filterSubDept(
              this.caseState.casefile.subRefType
            )[0].subCode,
            branch: this.filterBranchName(this.caseState.casefile.branch),
            branchCode: this.filterBranches(this.caseState.casefile.branch)[0]
              .brCode,
            insurer: this.filterIns(this.caseState.casefile.insurer)[0].name,
            recipient: this.findAdjEmail(assignedAdjuster),
            createdBy: this.$store.state.auth.user.id,
          };

          MailDataService.assignAdj(dataEmail)
            .then((response) => {
              this.closeAdj();
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "warning",
                text:
                  (response && response.data && response.data.message) ||
                  toString(),
              });
            })
            .catch((e) => {
              console.log(e);
            });
          this.dataEmail = "";
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        });
      this.closeAdj();
    },

    transferClerkSubmit() {
      if (!this.editedCasefile) return;
      const payload = {
        ...this.editedCasefile,
        clerkInCharge: this.editedCasefile.clerkInCharge,
        fileStatus: "CLERK",
        dateAssignFormatting: new Date().toISOString(),
        assignClerkBy: this.$store.state.auth.user.id,
      };
      CasefileDataService.update(this.editedCasefile.id, payload)
        .then((response) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "warning",
            text:
              (response && response.data && response.data.message) ||
              toString(),
          });
          this.caseState.casefile = payload; // update global after success
          this.closeTransferClerkDialog();
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        })
        .then(() => {
          var dataEmail = {
            id: this.editedCasefile.id,
            refType: this.filterDept(this.editedCasefile.refType)[0]
              .description,
            refTypeCode: this.filterDept(this.editedCasefile.refType)[0].name,
            subRefType: this.filterSubDept(this.editedCasefile.subRefType)[0]
              .subCodeDesc,
            subRefCode: this.filterSubDept(this.editedCasefile.subRefType)[0]
              .subCode,
            branch: this.filterBranchName(this.editedCasefile.branch),
            branchCode: this.filterBranches(this.editedCasefile.branch)[0]
              .brCode,
            insurer: this.filterIns(this.editedCasefile.insurer)[0].name,
            recipient: this.findUserEmail(this.editedCasefile.clerkInCharge),
            createdBy: this.$store.state.auth.user.id,
          };
          MailDataService.assignClerk(dataEmail)
            .then((response) => {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "warning",
                text:
                  (response && response.data && response.data.message) ||
                  toString(),
              });
            })
            .catch((e) => {
              console.log(e);
            });
          this.dataEmail = "";
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text:
              (e.response && e.response.data && e.response.data.message) ||
              e.message ||
              toString(),
          });
        });
      this.closeTransferClerkDialog();
    },

    closeAdj() {
      this.dialogAdj = false;
      this.$nextTick(() => {
        // this.caseState.casefile.fileStatus = "NEW";
      });
    },

    closeTransferClerkDialog() {
      this.dialogTransferClerk = false;
      this.editedCasefile = null;
      this.branch = { name: "", brCode: "" };
      this.$nextTick(() => {});
    },
  },
};
</script>
